module.exports = __webpack_public_path__ + "img/ksgjjzh.baff86bb.png";